<script>
import Button from '@/components/Button';
import InputComponent from '@/components/InputComponent';
import { mapState } from 'vuex';
import { setSolanaWallet } from '@/helpers/api/launchpad';

export default {
  name: 'SolanaModal',
  components: {
    Button,
    InputComponent,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value: '',
    loading: false,
  }),
  created() {
    this.$root.$on('showModal', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('showModal', this.showModal);
  },
  computed: {
    ...mapState({
      ethAddress: (state) => state.User.ethAddress,
    }),
    inputLength() {
      return this.value.length;
    },
  },
  methods: {
    hideModal() {
      this.$emit('update:show');
    },
    async sign() {
      try {
        this.loading = true;
        const message = this.value;
        const solana = this.value;
        const address = this.ethAddress;
        const signature = await this.$web3.eth.personal.sign(message, address);
        await setSolanaWallet(address, solana, signature);
        this.$store.dispatch('Simplesale/setSolana', { solana });
        this.hideModal();
        this.value = '';
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
  },
};
</script>

<template>
  <div>
    <v-dialog @input="$emit('update:show')" :value="show" overlay-opacity="0.8">
      <div class="modal main-block solana-modal">
        <h1>Type in your Solana wallet</h1>
        <h2>It is necessary to claim your tokens</h2>
        <InputComponent
          v-model="value"
          :class="{ err: inputLength !== 44 && inputLength }"
          :noFilter="true"
        />
        <Button @click="hideModal" class="mt-3 btn__w100 mr-5 cancel">Close</Button>
        <Button
          @click="sign"
          class="mt-3 btn__w100"
          :disabled="inputLength !== 44"
          :loading="loading"
          >Save</Button
        >
      </div>
    </v-dialog>
  </div>
</template>

<style lang="scss">
.solana-modal {
  h1 {
    font-size: 3.5rem;
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.2rem;
    text-align: left;
  }
}
</style>
